import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-20 md:pt-24">
        <section className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <nav className="text-sm text-foreground-500 mb-6">
              <a href="/" className="hover:text-primary-600 transition-colors">Home</a>
              <span className="mx-2">/</span>
              <span className="text-foreground-700">Contact</span>
            </nav>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">Contact Us</h1>
            <p className="text-foreground-600 text-lg">Have questions about CSSBuy Spreadsheet? Get in touch.</p>
          </div>
        </section>
        <section className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
          <div className="max-w-3xl mx-auto">
            <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8">
              <p className="text-foreground-700 mb-6">We are an independent resource hub for CSSBuy Spreadsheet information. For general inquiries, feedback, or suggestions, feel free to reach out.</p>
              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <i className="ri-mail-line text-primary-500 text-lg"></i>
                  <span className="text-foreground-700">contact [at] cssbuybr.help</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-global-line text-primary-500 text-lg"></i>
                  <span className="text-foreground-700">https://cssbuybr.help</span>
                </div>
              </div>
              <p className="text-foreground-500 text-sm mt-6">Note: We are not CSSBuy support. For order-related issues, please contact CSSBuy directly through their official channels.</p>
            </div>
            <div className="text-center mt-8">
              <a href="/" className="inline-flex items-center px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-md transition-colors">
                <i className="ri-arrow-left-line mr-2"></i>
                Back to Homepage
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}